module.exports = __webpack_public_path__ + "static/media/CircularStd-Bold.bd1f8d24.woff2";